
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const FriendSlider = ({friends}) => {

      const settings = {
              dots: true,
              infinite: true,
              speed: 600,
              slidesToShow: 3,
              slidesToScroll: 1,
              variableWidth: true,
              autoplay: true,
              autoplaySpeed: 2000,
              cssEase: 'ease-in-out'
      }

      return (
            <div>
                  <Slider {...settings}>
                        {
                              friends.map((item, index) => (
                                    <div className="friend_card" key={index}>
                                          <a href={item.me} className="friend_card__link" target="_blank" rel="noreferrer">
                                                <img src={item.avatar === '' ? `https://api.dicebear.com/5.x/initials/svg?seed=${item.name}&font-size=26` : item.avatar} alt={item.name} />
                                                <strong>{item.name}</strong>
                                          </a>
                                    </div>
                              ))
                        }
                        
                  </Slider>
            </div>
      )
                
}

export default FriendSlider
